import React from "react";
import { BRAND } from "../config/brand";

/**
 * Spinning sun loading component — iter413c-17 uses our branded SLUNCE.png
 * (the Solar Green sun mark) with smooth rotation. Falls back to inline SVG
 * if image fails to load.
 *
 * size: "sm" | "md" | "lg" | "xl"
 * text: optional loading text
 * fullscreen: center on full screen
 */
function SunMark({ px }) {
  return (
    <img
      src="/images/slunce.png"
      alt={BRAND.productName}
      width={px}
      height={px}
      draggable={false}
      style={{
        width: px,
        height: px,
        animation: "sun-spin 2.4s linear infinite",
        filter: "drop-shadow(0 4px 18px rgba(251,191,36,0.45))",
        userSelect: "none",
      }}
    />
  );
}

const SPIN_KEYFRAMES = `
  @keyframes sun-spin {
    0%   { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export default function SunLoader({ size = "md", text = "", fullscreen = false }) {
  const sizes = { sm: 32, md: 56, lg: 80, xl: 120 };
  const px = sizes[size] || 56;

  const spinner = (
    <div className="flex flex-col items-center gap-3">
      <SunMark px={px} />
      {text && (
        <p className="text-slate-500 dark:text-slate-400 text-sm font-medium animate-pulse">{text}</p>
      )}
      <style>{SPIN_KEYFRAMES}</style>
    </div>
  );

  if (fullscreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white/80 dark:bg-slate-950/80 backdrop-blur-sm z-50">
        {spinner}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-6">
      {spinner}
    </div>
  );
}

/** Fullscreen initial page load */
export function PageLoader() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-amber-50 to-white dark:from-slate-900 dark:to-slate-950 gap-4">
      <SunMark px={96} />
      <p className="text-slate-600 dark:text-slate-300 text-base font-medium animate-pulse">{BRAND.loadingText}</p>
      <style>{SPIN_KEYFRAMES}</style>
    </div>
  );
}
